import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { useAtom } from 'jotai';
import mixpanel from 'mixpanel-browser';
import { AuthProvider, UrqlProvider } from '@web/api';
import ScrollToTop from '@/components/ScrollToTop/ScrollToTop';
import { env } from '@/env';
import { UserProvider } from '@/provider';
import { logoutAtom } from '@/store/atoms';
import ThemeProvider from '@/theme';
import app from '../../package.json';
import { datadogRum } from '@datadog/browser-rum';

if (env.VITE_DATADOG_APPLICATION_ID && env.VITE_DATADOG_CLIENT_TOKEN) {
  datadogRum.init({
    applicationId: env.VITE_DATADOG_APPLICATION_ID,
    clientToken: env.VITE_DATADOG_CLIENT_TOKEN,
    proxy: env.VITE_DATADOG_PROXY,
    site: 'datadoghq.eu',
    service: env.VITE_SRV_NAME,
    allowedTracingUrls: [
      {
        match: env.VITE_GRAPH_API_URL,
        propagatorTypes: ['datadog', 'tracecontext'],
      },
    ],
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
  });
  datadogRum.startSessionReplayRecording();
}

if (env.VITE_MIXPANEL_TOKEN) {
  mixpanel.init(env.VITE_MIXPANEL_TOKEN, {
    debug: env.VITE_NODE_ENV === 'development' ? false : true,
    track_pageview: true,
    persistence: 'localStorage',
  });
}

export default function App() {
  const [, setLogout] = useAtom(logoutAtom);

  return (
    <ThemeProvider>
      <AuthProvider
        authUrl={env.VITE_HANKO_API_URL}
        onLogout={setLogout}
        useNavigate={useNavigate}
      >
        <UrqlProvider
          graphUrl={env.VITE_GRAPH_API_URL}
          usage={{ name: app.name, version: app.version }}
        >
          <UserProvider>
            <Toaster />
            <ScrollToTop />
            <Outlet />
          </UserProvider>
        </UrqlProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
